module.exports = __webpack_public_path__ + "fromBrideToParents-jp-r.970a9f6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-jp-r.jpg
// module id = MPiF
// module chunks = 0